import { Component } from 'react';
import { asField } from 'informed';
import { Button } from 'components/common';
import { FileUploader } from 'components/common/uploader';

const ImageUploader = asField(
  class extends Component {
    state = {
      image: this.props.fieldState.value ? this.props.fieldState.value : null,
      imageAdded: false,
      preview: null
    };

    componentDidMount() {
      if (this.props.setUploader) this.props.setUploader(this);
    }

    handleFileAdded = () => {
      this.setState({ imageAdded: true });
    };

    handleFileCanceled = () => {
      this.setState({ imageAdded: false, preview: null });
      if (this.props.onFileRemoved) this.props.onFileRemoved();
    };

    handleThumbnailGenerated = ({ preview }) => {
      this.setState({ preview });
      if (this.props.onThumbnailGenerated)
        this.props.onThumbnailGenerated(preview);
    };

    handleUploadSuccess = ({ filename, url }) => {
      this.props.fieldApi.setValue(url);
      this.setState({ image: url, preview: null });
    };

    handleRemoveClick = () => {
      this.props.fieldApi.setValue(null);
      this.setState({ image: null, preview: null });
    };

    setUploader = (uploader) => {
      this.uploader = uploader;
    };

    upload = async (sendNotice = true) => {
      if (!this.state.imageAdded) return null;
      const result = await this.uploader.upload(sendNotice);
      return result;
    };

    render() {
      const { id, maxWidth, messages, showPreviewImage } = this.props;

      return (
        <div className="image">
          <div className="actions">
            <div className="upload">
              <FileUploader
                allowedFileTypes={['image/*']}
                getUploader={this.setUploader}
                id={`image-uploader-${id}`}
                keyPrefix="uploads/images/original/"
                onFileAdded={this.handleFileAdded}
                onFileRemoved={this.handleFileCanceled}
                onThumbnailGenerated={this.handleThumbnailGenerated}
                onUploadSuccess={this.handleUploadSuccess}
                uuidAsFilename={true}
              />
            </div>

            {this.state.image ? (
              <Button
                category="danger"
                icon="trash-alt"
                onClick={this.handleRemoveClick}
                size="small"
                style={{
                  padding: '7px 10px 8px',
                  position: 'relative',
                  top: -1
                }}
                text={messages.commonRemove}
              />
            ) : null}
          </div>

          {showPreviewImage && (this.state.preview || this.state.image) ? (
            <div className="preview">
              <img
                src={this.state.preview || this.state.image}
                style={{ maxWidth }}
              />
            </div>
          ) : null}

          <style jsx>{`
            .upload {
              display: inline-block;
              margin-right: 15px;
            }
            .preview {
              margin-top: 15px;
            }
          `}</style>
        </div>
      );
    }
  }
);

export default ImageUploader;
